var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('rfl-form',{attrs:{"presumptiveDataEach":_vm.referPresumptiveDataEach},on:{"emitForm":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }